import React from 'react';
import { Button } from './ui/Button';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42804528906311:1';
export function FinalCTA() {
  return <section className="relative overflow-hidden py-24 md:py-32 px-4 border-t border-zinc-800/50" data-id="element-163">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 blur-[150px] rounded-full pointer-events-none" data-id="element-164" />

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-165">
        <h2 className="text-4xl md:text-7xl font-extrabold mb-8 tracking-tight leading-tight" data-id="element-166">
          TODO TU AÑO DE HIIT <br data-id="element-167" />
          <span className="text-primary" data-id="element-168">RESUELTO</span>
        </h2>

        <p className="text-xl md:text-3xl text-zinc-300 mb-10 font-medium" data-id="element-169">
          300+ clases listas. 52 semanas organizadas. Acceso inmediato.
        </p>

        {/* Price */}
        <div className="flex items-end justify-center gap-3 mb-3" data-id="element-170">
          <span className="text-zinc-500 line-through text-xl font-bold" data-id="element-171">
            $51.900
          </span>
          <span className="text-5xl md:text-6xl font-extrabold text-white leading-none" data-id="element-172">
            $19.990 <span className="text-xl text-zinc-500" data-id="element-173">ARS</span>
          </span>
        </div>
        <div className="inline-flex items-center gap-2 bg-primary/15 border border-primary/30 rounded-full px-4 py-1.5 text-[11px] md:text-sm font-bold text-primary uppercase tracking-wider mb-10" data-id="element-174">
          🔥 Precio promocional de lanzamiento
        </div>

        <Button href={URL_COMBO} className="text-xl md:text-2xl py-6 px-12 w-full md:w-auto shadow-[0_0_50px_rgba(249,168,212,0.3)] block md:inline-flex" data-id="element-175">
          QUIERO MI COMBO AHORA
        </Button>
      </div>
    </section>;
}